import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  Box,
} from '@mui/material';
import Divider from '../divider/Divider';
import TypographyBlock from '../typography_block/typographyblock';
import { ExpandMoreOutlined } from '@mui/icons-material';
import {
  footerListPropTypes,
  footerListDefaultProps,
} from './FooterList.propTypes';
import commonUtil from '../../../utils/commonUtil';

const FooterList = ({ actions, sections, backgroundColor }) => {
  const handleItemClick = link => {
    commonUtil.handleRedirection(link);
    window.scrollTo(0, 0);
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleAccordionChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <Box sx={{ backgroundColor, color: '#89CFF0', width: '100%' }}>
      {sections.map((section, index) => (
        <Box key={index} sx={{ width: '100%' }}>
          <Divider backgroundColor="#FFFFFF" />
          <Accordion
            sx={{ backgroundColor, color: '#68D3E3' }}
            disableGutters
            elevation={0}
            expanded={expanded === `panel${index}`}
            onChange={handleAccordionChange(`panel${index}`)}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreOutlined
                  fontSize="small"
                  sx={{ color: '#ffffff' }}
                />
              }
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
              sx={{
                p: 0,
                '& .MuiTypography-root': {
                  fontSize: '18px',
                  lineHeight: '24px',
                },
              }}
            >
              <TypographyBlock
                headerVariant="h6"
                headerChildren={section.title}
                fontFamily="heading.fontFamily.primary"
                FontWeight="700"
                headerColor="#68D3E3"
              />
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <List sx={{ p: 0 }}>
                {section.items.map((item, idx) => (
                  <ListItem
                    key={idx}
                    sx={{
                      paddingLeft: 0,
                      '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                      },
                      '& .MuiTypography-root': {
                        fontSize: '16px',
                        lineHeight: '18.78px',
                        fontFamily: 'body.fontFamily.secondary',
                      },
                    }}
                    onClick={() => handleItemClick(item.url)}
                  >
                    <TypographyBlock
                      paragraphChildren={item.label}
                      fontFamily="body.fontFamily.secondary"
                      FontWeight="400"
                      paragraphColor="#ffffff"
                    />
                  </ListItem>
                ))}
              </List>
            </AccordionDetails>
          </Accordion>
        </Box>
      ))}
      <Divider backgroundColor="#FFFFFF" />
    </Box>
  );
};

FooterList.propTypes = footerListPropTypes;
FooterList.defaultProps = footerListDefaultProps;

export default FooterList;
